import React from "react";

const Footer = () => {
  return (
  <div>
    <section className="footer">
        <p className="m-0" style={{fontSize: '45px', color: '#ffffff', lineHeight: '80%'}}>GAUSH</p>
        <img src="/images/line.png" style={{width: '3px'}}/>
        <div className="social-icons">
            <a href="https://www.instagram.com/gaushmusic" target="_blank"><img src="/images/instagram.png"/></a>
            <a href="https://open.spotify.com/artist/5UPhqOBfNq83B0vOaLocFM" target="_blank"><img
                    src="/images/spotify.png"/></a>
            <a href="https://www.youtube.com/channel/UCt6fAQKhWqaUESK86mjrOLw" target="_blank"><img
                    src="/images/youtube.png"/></a>
            <a href="https://music.apple.com/us/artist/gaush/1537261706" target="_blank"><img
                    src="/images/apple-music.png"/></a>
            <a href="https://www.jiosaavn.com/artist/gaush/6eYuRpJifqI_" target="_blank"><img
                    src="/images/jio-saavn.png"/></a>
        </div>
    </section>
    <section className="post-footer">
        <p className="m-0">DESIGNED AND BUILT BY SAMARTH JAIN</p>
    </section>

    
  </div>
  );
};

export default Footer;
